import React, { useEffect, useState } from 'react';
import '../outward/Outwarddetail.css';
import Outcontainerheader from './Outcontainerheader';
import MasterDataService from '../../services/masterData.service';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Swal from 'sweetalert2';
import CreatableSelect from 'react-select/creatable';
import moment from 'moment';
import OutwardDetailService from '../../services/outwarddetail.sercice';
import AccountService from '../../services/accountData.service';
import OutwardLogService from '../../services/outwardlog.service';

const customStyles = {
  option: (provided: any, { isFocused, isSelected }: any) => ({
    ...provided,
    padding: 5,
    zIndex: 1,
    background: isFocused ? 'hsl(0deg 1.44% 56.86%)' : isSelected ? 'hsl(0deg 0% 20% / 65%)' : undefined,
  }),
  control: (prev: any) => ({
    ...prev,
    padding: 0,
    width: "100%"

  }),
  menu: (base: any, { isFocused, isSelected }: any) => ({
    ...base,
    zIndex: 100,
    background: isFocused ? 'hsl(0deg 1.44% 56.86%)' : isSelected ? 'hsl(0deg 0% 20% / 65%)' : undefined,
  }),
}


function Outwarddetailentry() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [branch, setBranch] = useState((localStorage.userDetails) ? JSON.parse(localStorage.userDetails).branch : 0);
  const [shipmentmode, setshipmentmode] = useState([])
  const [modeName, setmodeName] = useState('');
  const [multiplyFactor, setmultiplyFactor] = useState(5000);
  const [modeId, setmodeId] = useState(0);
  const [serviceProvider, setserviceProvider] = useState('');
  const [serviceProviderId, setserviceProviderId] = useState(0);
  const [serviceProviderList, setserviceProviderList] = useState([]);
  const [allEmployee, setAllEmployee] = useState([]);
  const [employeeId, setemployeeId] = useState('');
  const [employeeName, setEmployeeName] = useState('');

  const [costCenter, setcostCenter] = useState(0);
  const [allCostCenter, setallCostCenter] = useState([]);
  const [ratesContract, setRatesContract] = useState<any | []>(null);
  const [costCenterLabel, setcostCenterLabel] = useState('');


  const [outwardDate, setoutwardDate] = useState((moment(new Date())).format('YYYY-MM-DD'));
  const [outwardTime, setoutwardTime] = useState((moment(new Date()).utcOffset('+0530')).format('HH:mm'));


  const [consignor, setConsignor] = useState("")
  const [consignorName, setConsignorName] = useState("")
  const [consignorZipCode, setConsignorZipCode] = useState("")
  const [allSelections, setallSelections] = useState([])

  const [allBranch, setallBranch] = useState([]);
  const [consigneeBranchId, setconsigneeBranchId] = useState(0);
  const [consigneebranchLabel, setconsigneeBranchLabel] = useState('');
  const [detinationBranchShowhide, setdetinationBranchShowhide] = useState('none');

  const [direct, setdirect] = useState(0);
  const [batchNo, setbatchNo] = useState('');
  const [courierType, setcourierType] = useState(0);
  const [refNo, setrefNo] = useState('');
  const [outwardType, setoutwardType] = useState(0);
  const [consigneeId, setconsigneeId] = useState('');
  const [consigneeName, setconsigneeName] = useState('');
  const [consigneePhoneNumber, setconsigneePhoneNumber] = useState('');
  const [consigneeCityName, setconsigneeCityName] = useState('');
  const [consigneeZipCode, setconsigneeZipCode] = useState('');
  const [consigneeAreaName, setconsigneeAreaName] = useState('');
  const [consigneeStateName, setconsigneeStateName] = useState('');
  const [consigneeCountryCode, setconsigneeCountryCode] = useState('');
  const [employeeTableId, setemployeeTableId] = useState(0);
  const [department, setdepartment] = useState('');
  const [remark, setremark] = useState('');
  const [product, setproduct] = useState(0);
  const [AWB, setAWB] = useState('');
  const [numberOfPieces, setnumberOfPieces] = useState(1);
  const [weight, setweight] = useState<any | 0.00>(0);
  const [volumetricWeight, setvolumetricWeight] = useState<any | 0.00>(0);
  const [chargableWeight, setchargableWeight] = useState(0);
  const [serviceLocation, setserviceLocation] = useState(0);
  const [serviceRequest, setserviceRequest] = useState(0);
  const [productName, setproductName] = useState('');
  const [allProduct, setallProduct] = useState([]);
  const [mailContent, setmailContent] = useState('');
  const [shipmentType, setshipmentType] = useState(0);
  const [zoneName, setzoneName] = useState('');
  const [zoneId, setzoneId] = useState(0);
  const [deliveryTat, setdeliveryTat] = useState('');
  const [serviceStatus, setserviceStatus] = useState('');
  const [netAmount, setnetAmount] = useState<any | 0.00>(0);
  const [fuelCharges, setfuelCharges] = useState<any | 0.00>(0);
  const [otherCharges, setotherCharges] = useState<any | 0.00>(0);
  const [GST, setGST] = useState<any | 0.00>(0);
  const [grossAmount, setgrossAmount] = useState<any | 0.00>(0);


  const [pinvalue, setpinvalue] = useState([]);
  const [pincodeId, setPincodeId] = useState(0);
  const [boxlength, setboxLength] = useState(0);
  const [boxwidth, setBoxWidth] = useState(0);
  const [boxheight, setBoxHeight] = useState(0);
  const [hideshowtable, sethideshowtable] = useState(false)
  const [allPendigbatches, setallPendigbatches] = useState<any[]>([])
  const [inputValue, setInputValue] = useState('');


  const pendingBatchesList = () => {
    OutwardLogService.getOutwardLogPendingList().then((data) => {
      if (Array.isArray(data)) {
        setallPendigbatches(data)
      }
    })
  }
  useEffect(() => {
    getShipmentMode();
    pendingBatchesList();
    // getServiceProvider();
    getAllEmployee();
    getCostCenter();
    getBranch();
    getOutwardDetailsById()
  }, [])

  const getOutwardDetailsById = () => {
    if(state !== null){
      OutwardDetailService.getOutwardDetailsById(state).then((data)=>{
if(data){
      setmodeId(data.modeName)
      setcourierType(data.courierType)
      setconsigneeAreaName(data.consigneeAddress)
      setconsigneeBranchId(data.consigneeBranchId)
      setcostCenter(data.costCenter)
      setconsigneeId(data.consigneeId)   
      setconsigneeZipCode(data.consigneeZipCode)   
      setconsigneeAreaName(data.consigneeAreaName)
      setrefNo(data.refNo)
      setremark(data.remark)
      setAWB(data.AWB)
      setserviceProviderId(data.serviceProvider)
      setproduct(data.product)
      setproductName(data.productName)
      setoutwardTime(data.outwardTime)
      setoutwardDate(data.outwardDate)
      setbatchNo(data.batchNo)
      setconsigneeCityName(data.consigneeCityName)
      setconsigneeStateName(data.consigneeStateName)
      setconsigneeCountryCode(data.consigneeCountryCode)
      setEmployeeName(data.employeeName)
      setnumberOfPieces(data.numberOfPieces)
      setmailContent(data.mailContent)
      setboxLength(data.boxlength)
      setshipmentType(data.shipmentType)
      setBoxHeight(data.boxheight)
      setBoxWidth(data.boxwidth)
      setvolumetricWeight(data.volumetricWeight)
      setweight(data.weight)
      setnetAmount(data.netAmount)
      setGST(data.gstAmount)
      setotherCharges(data.otherCharges)
      setgrossAmount(data.grossAmount)
      setoutwardType(data.outwardType)
      if(data.outwardType === 0){        
      setconsigneeId(data.consigneeName)   
      } else {
        setconsigneeId(data.consigneeId)    
      }
}
      })

    }
  }

  const getShipmentMode = () => {
    MasterDataService.GetshipmentMode().then(
      async (data) => {
        if (data) {
          const options = data.map((d: any) => ({
            "value": d.id,
            "label": d.modeName,
            "multiplyFactor": d.multiplyFactor
          }))
          await setshipmentmode(options)
          if (state === null) {
            if (data[0]) {
              await setmodeId(data[0]['id'])
              await setmodeName(data[0]['modeName'])
              await setmultiplyFactor(data[0]['multiplyFactor'])
            }
          } 
        }
      }
    );
  }
  useEffect(()=>{
    let modesNames = shipmentmode.find((item: any) => {
      return item['value'] === modeId
    });
    if (modesNames !== undefined) {
      setmodeName(modesNames['label'])
      setmultiplyFactor(modesNames['multiplyFactor'])
    }
  },[modeId, shipmentmode])
  
  // const getServiceProvider = () => {
  //   MasterDataService.GetserviceProvider().then(
  //     async (data) => {
  //      if (data) {
  //         const options = data.map((d: any) => ({
  //           "value": d.id,
  //           "label": d.serviceProviderName
  //         }))
  //         await setserviceProviderList(options)
  //         if (state === null) {
  //           if (data[0]) {
  //             await setserviceProviderId(data[0]['id'])
  //             await setserviceProvider(data[0]['serviceProviderName'])
  //           }
  //         } else {
  //           let serviceProviderLists = data.find((item: any) => {
  //             return item.id === serviceProviderId
  //           });
  //           if (serviceProviderLists !== undefined) {
  //             setserviceProvider(serviceProviderLists.serviceProviderName)
  //           }
  //         }
  //       }
  //     }
  //   )
  // }
  const getAllEmployee = async () => {
    await MasterDataService.getEmployeeList().then(
      async (data) => {
        if (data) {
          const options = data.map((d: any) => ({
            "value": d.id,
            "label": d.employeeName,
            'costCenter': d.costCenter,
            'employeeId': d.employeeId
          }))
          setAllEmployee(options);
          if (state === null) {
            if (data[0]) {
              setemployeeTableId(data[0]['id'])
              await setemployeeId(data[0]['employeeId'])
              await setEmployeeName(data[0]['employeeName'])
              setcostCenter(data[0]['costCenter'])
            }
          }

        }
      }
    );
  }
  useEffect(() => {
    setEmployee();
  }, [employeeTableId, allEmployee])
  const setEmployee = async () => {
    let employeeLists = allEmployee.find((item: any) => {
      return item['value'] === employeeTableId
    });
    if (employeeLists !== undefined) {
      setEmployeeName(employeeLists['label'])
      setcostCenter(employeeLists['costCenter'])
    }
  }
  const getCostCenter = async () => {
    await MasterDataService.getCostCenter().then(
      async (data) => {
        if (data) {
          const options = data.map((d: any) => ({
            "value": d.id,
            "label": d.costCenter
          }))
          await setallCostCenter(options)
          if (state === null) {
            await setcostCenter(data[0]['id'])
            setcostCenterLabel(data[0]['costCenter'])
          }
        }
      }
    )
  }
  useEffect(() => {
    setCoseCenter();
  }, [costCenter, allCostCenter])
  const setCoseCenter = () => {
    let costCenters = allCostCenter.find((item: any) => {
      return item['value'] === costCenter
    });
    if (costCenters !== undefined) {
      setcostCenterLabel(costCenters['label'])
    }
  }

  // useEffect(() => {
  //   getPincode();
  // }, [courierType])
  const handleInputChange = async (input:any) => {
    if(input.length > 3){
   return  await MasterDataService.getAllPincodeByCountryWiseAutoComplte(courierType, input).then(
      (data) => {
       const zipCodeList = data.map((d: any) => ({
          "value": d.id,
          "label": d.zipCode
        }))
        return zipCodeList;
        // setpinvalue(zipCodeList)
        // if (state === null) {
        //   if (data[0]) {
        //     setPincodeId(data[0]['id'])
        //     setconsigneeZipCode(data[0]['zipCode'])
        //   }
        // }
      }
    )  }  
  };
  const getPincode = async () => {
    await MasterDataService.getAllPincodeByCountryWise(courierType).then(
      (data) => {
        const zipCodeList = data.map((d: any) => ({
          "value": d.id,
          "label": d.zipCode
        }))
        setpinvalue(zipCodeList)
        if (state === null) {
          if (data[0]) {
            setPincodeId(data[0]['id'])
            setconsigneeZipCode(data[0]['zipCode'])
          }
        }
      }
    )
  }

  const setPincodeDetails = () => {
    let pinCodeLists = pinvalue.find((item: any) => {
      return item['value'] === pincodeId
    });
    if (pinCodeLists !== undefined) {
      setconsigneeZipCode(pinCodeLists['label'])
    }
  }

  useEffect(() => {
    console.log("consigneeZipCode", consigneeZipCode)
    if(consigneeZipCode.length > 3)
   { setPincodeDetails()
    getCityStateCountryInfo(consigneeZipCode)}
  }, [pinvalue, pincodeId])

  const getCityStateCountryInfo = async (value: any) => {
    await MasterDataService.getPincodeCityInfo(value).then(
      (data) => {
        if (data) {
          setconsigneeCityName(data.cityName)
          setconsigneeStateName(data.stateName)
          setconsigneeCountryCode(data.countryName)
        }
      }
    )
  }

  //  get branch options
  const getBranch = async () => {
    await MasterDataService.getBranch().then(
      async (data) => {
        if (data) {
          const options = data.map((d: any) => ({
            "value": d.id,
            "label": d.branchName
          }))
          await setallBranch(options)
          if (state === null) {
            if (data[0]) {
              await setconsigneeBranchId(data[0]['id'])
              await setconsigneeBranchLabel(data[0]['branchName'])
            }
          } else {
            let branchLists = data.find((item: any) => {
              return item.id === consigneeBranchId
            });
            if (branchLists !== undefined) {
              setconsigneeBranchLabel(branchLists.branchName)
            }
          }
        }
      }
    )
  }
  const handleBranchChange = async (e: any) => {
    await setconsigneeBranchId(e.value)
    await setconsigneeBranchLabel(e.label)
    getBranchEmployeeList(e.value);
  };
  const getBranchEmployeeList = async (value: Number) => {
    await MasterDataService.getBranchEmployeeByBranchId(value).then(
      async (data) => {
        if (data) {
          const options = data.map((d: any) => ({
            "value": d.id,
            "label": d.employeeName,
            "consigneeAddress": d.fullAddress,
            "pincode": d.pincode,
            "pincodeId": d.zipCode

          }))
          await setallSelections(options)
          if (state === null) {
            if (data[0]) {
              await setconsigneeId(data[0]['id'])
              await setconsigneeName(data[0]['employeeName'])
              await setconsigneeAreaName(data[0]['consigneeAddress'])
              await setPincodeId(data[0]['zipcode'])
            }
          } else {
            let branchwiseEmployeeLists = data.find((item: any) => {
              return item.id === consigneeId
            });
            if (branchwiseEmployeeLists !== undefined) {
              setconsigneeName(branchwiseEmployeeLists.employeeName)
              await setconsigneeAreaName(branchwiseEmployeeLists.consigneeAddress)
              await setPincodeId(branchwiseEmployeeLists.pincodeId)
            }
          }
        }
      }
    )
  }
  const onToDestinationChange = (value: Number) => {
    if (value === 1) {
      setdetinationBranchShowhide('flex')
      setoutwardType(1)
    } else {
      setdetinationBranchShowhide('none')
      setoutwardType(0)
    }
  }


  useEffect(() => {
    getServiceProviderbypincode()
  }, [consigneeZipCode])
  const getServiceProviderbypincode = async () => {
    if (consigneeZipCode !== undefined) {
      await OutwardDetailService.getServiceProviderbyPincode(consigneeZipCode, modeId).then(
        (data) => {
          if (data.length !== 0) {
            const options: any = data.map((d: any) => ({
              "value": d.serviceProviderId,
              "label": d.serviceProviderName,
              "zoneId": d.zoneId,
              "zoneName": d.zoneName,
              "deliveryTat": d.serviceTat,
              "serviceable": "Yes"
            }))
            setserviceProviderList(options)
            if (state === null) {
              if (data[0]) {
                setserviceProviderId(data[0]['serviceProviderId'])
                setserviceProvider(data[0]['serviceProviderName'])
                setzoneName(data[0]['zoneName'])
                setzoneId(data[0]['zoneId'])
                setdeliveryTat(data[0]['serviceTat'])
                setserviceStatus("Yes")
              }
            }
          } else {
            setserviceProviderId(0)
            setserviceProvider('')
            setzoneName('')
            setzoneId(0)
            setdeliveryTat('')
            setserviceStatus('')
          }
        }
      )
    }
  }
  const setServiceProviderfn = () => {
    let serviceProviderLists = serviceProviderList.find((item: any) => {
      return item['value'] === serviceProviderId
    });
    if (serviceProviderLists !== undefined) {
      setserviceProviderId(serviceProviderLists['value'])
      setserviceProvider(serviceProviderLists['label'])
      setzoneName(serviceProviderLists['zoneName'])
      setzoneId(serviceProviderLists['zoneId'])

      console.log("serviceProviderLists['zoneId']",serviceProviderLists['zoneId'])
    }
  }

  useEffect(() => {
    setServiceProviderfn();
  }, [serviceProviderId, serviceProviderList])
  useEffect(() => {
    getProduct(serviceProviderId);
  }, [serviceProviderId, zoneId])
  const getProduct = async (value: number) => {
    if (value !== 0) {
      await AccountService.getProductsByServiceProviderandZone(value, branch, zoneId).then(
        async (data) => {
          console.log("Products Data", data)
          if (data.length > 0) {
            const options = data.map((d: any) => ({
              "value": d.id,
              "label": d.productName
            }))
            await setallProduct(options)
            if (state === null) {
              if (data[0]) {
                await setproduct(data[0]['id'])
                await setproductName(data[0]['productName'])
              }
            }
          }
           else {
            await setproduct(0)
            await setproductName('')
            setallProduct([])
          }
        }
      )
    } 
    else {
      await setproduct(0)
      await setproductName('')
      setallProduct([])
    }
  }

  //   useEffect(() => {
  //     getZonebyPincodeandProduct()
  //   },[consigneeZipCode, product])

  //   const getZonebyPincodeandProduct = async () => {
  // await OutwardDetailService.getZonebyPincodeandProduct(product, consigneeZipCode).then((data)=>{
  //   console.log(data)
  // })
  //   }

  const handleEdit = () => {

  }
  const handleDelete = () => {

  }
  const handleSubmit = () => {
    if (batchNo === "") {
      setdirect(1)
    }
    OutwardDetailService.postoutwardData(direct, outwardType, batchNo, courierType, modeId, outwardDate, outwardTime, employeeTableId, employeeName, employeeId, costCenter, refNo, AWB, consigneeId, consigneeName, consigneeAreaName, consigneeBranchId, consigneeCityName, consigneePhoneNumber, consigneeStateName, consigneeZipCode, consigneeCountryCode, serviceProviderId, productName, product, zoneId, boxlength, boxwidth, boxheight, volumetricWeight, numberOfPieces, weight, netAmount, fuelCharges, otherCharges, GST, grossAmount, mailContent, shipmentType).then(
      (data) => {
        if (data) {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: data,
            showConfirmButton: false,
            timer: 1500,
          }).then(()=>{
            navigate('../outwarddetailslist'); 
          });
          // const timer = setTimeout(() => {
          //   // Navigate to another page after the timer completes
          //   navigate('/outwarddetailslist'); 
          //   // Change '/another-page' to your desired route
          // }, 1500);      
          // // Clear the timer if the component unmounts before the timer completes
          // return () => clearTimeout(timer);
        }
      }
    )
  }
  const opendialagforPreviousBatch = () => {
    pendingBatchesList()
    sethideshowtable(true)
  }

  const clearForm = () => {
    setbatchNo('')

  }

  //----------------- Calculations --------------

  useEffect(() => {
    setVolumatricWeightFn()
    calculateHighstWeight()
  }, [boxwidth, boxheight, boxlength, modeId])

  const setVolumatricWeightFn = () => {
    const calculatedWeight = (boxwidth * boxheight * boxlength / multiplyFactor).toFixed(3);
    setvolumetricWeight(calculatedWeight);
  }
  useEffect(() => {
    calculateHighstWeight()
  }, [weight, volumetricWeight])
  
  let highestWeight = 0
  const calculateHighstWeight = () => {
    if (weight !== "" && volumetricWeight !== null) {

      if (volumetricWeight !== 0 || weight !== 0) {
        if (volumetricWeight > weight) {
          highestWeight = volumetricWeight
        } else {
          highestWeight = weight
        }
      }
    }
  }
  useEffect(() => {
    getRateChartsByProductandZone()
  }, [modeId, serviceProviderId, product, zoneId])

  const getRateChartsByProductandZone = () => {
    console.log("Rate contract Change", product)
    if ((modeId !== 0) && (serviceProviderId !== 0) && (product !== 0) && (zoneId !== 0)) {

      AccountService.getRateContractByProductandzones(modeId, serviceProviderId, product, zoneId).then((data) => {
        setRatesContract(data)
        console.log("Rate contract Change", data)
      })
    }

  }

  useEffect(() => {
    calculateNetAmount()
  }, [weight, volumetricWeight, product, serviceProviderId])
  const calculateNetAmount = () => {
    // calculate 
    console.log("ratesContract call", ratesContract)
    if ((ratesContract !== "") && (ratesContract !== null)) {
      // console.log("ratesContract", ratesContract)
      const additionalWeight = ratesContract.additionalWeight
      const additionalRate = ratesContract.additionalRate
      const surcharge = ratesContract.surcharge
      const fuelSurcharge = ratesContract.fuelSurcharge
      const loadingCharge = ratesContract.loadingCharge
      const unloadingCharge = ratesContract.unloadingCharge
      const rateContractDetail = ratesContract.rateContractDetail

      // console.log("additional Weight", additionalWeight, " Weight :", highestWeight)
      // console.log("Highest Weight", highestWeight)
      // console.log("rates", rateContractDetail)
      let chargebaleWeight = highestWeight

      let selectedSlab = null;
      let difference = 0;
      if ((rateContractDetail.length > 0) && highestWeight !== 0) {
        for (const slab of rateContractDetail) {
          if (highestWeight >= slab.slabStart && highestWeight <= slab.slabEnd) {
            selectedSlab = slab;
            break; // Found the matching slab, no need to continue
          }
        }

        if (!selectedSlab) {
          // If no matching slab found, use the highest slabEnd slab
          const highestSlab = rateContractDetail.reduce((maxSlab: any, currentSlab: any) =>
            currentSlab.slabEnd > maxSlab.slabEnd ? currentSlab : maxSlab
          );
          selectedSlab = highestSlab;
          difference = highestWeight - highestSlab.slabEnd;
        }
      }
      let additionWeightSlab = 0;
      let docCharges: any = 0;
      additionWeightSlab = Math.ceil(difference / additionalWeight);
      if (selectedSlab) {
        docCharges = (selectedSlab.slabRate + additionWeightSlab * additionalRate).toFixed(2)
        chargebaleWeight = selectedSlab.slabEnd + additionWeightSlab * additionalWeight;
      }
      setnetAmount(parseFloat(docCharges));

      let fuelSurc = (docCharges * fuelSurcharge / 100).toFixed(2)
      setfuelCharges(parseFloat(fuelSurc))

    }
  }
  useEffect(() => {
    calculateGrandTotalFn();
  }, [netAmount, otherCharges])

  const calculateGrandTotalFn = () => {
    let gstAmount = ((netAmount + fuelCharges + otherCharges) * 0.18).toFixed(2)
    setGST(parseFloat(gstAmount))
    if (otherCharges === "") {
      setotherCharges(0)
    }
    let grossAmt = (parseFloat(gstAmount) + parseFloat(otherCharges) + parseFloat(fuelCharges) + parseFloat(netAmount)).toFixed(2)
    setgrossAmount(parseFloat(grossAmt))
  }
  //--------------------Calculations End ------------
  return (
    <>
      <Outcontainerheader />
      <div style={{ margin: "0px" }}>
        <div style={{ display: "flex", flexDirection: "column", paddingTop: "1%" }}>
          <div className="container col-10">
            <div className="themeColor" style={{ width: '100%', paddingLeft :'0px', paddingRight : '0px' }} ><p style={{ marginLeft: "10px" }}> Outward Details List</p></div>
            <div className='width card'>
              <div className='width inline section-1 margin-left'>

                <div className='col-3 inline sec4-radio'>
                  <label className='col-4'>  Mode </label>
                  <Select
                    name="modeId"
                    onChange={(e: any) => { setmodeId(e.value); setmodeName(e.label) }}
                    options={shipmentmode}
                    className='col-8 select'
                    value={{ value: modeId, label: modeName }}
                    styles={customStyles} />
                </div>
                <div className='col-2 inline sec4-radio'>
                  <div className='sec4-radio1 direct1'>
                    <label className='inline' ><input
                      name="connected"
                      id="home"
                      type="radio"
                      value="first"
                      className="sec1-radio radio-btn"
                      onChange={() => { setcourierType(0); }}
                      checked={courierType === 0 && true}
                    />Domestic </label>
                  </div>
                  <div className='sec4-radio1 direct1'>
                    <label className='inline' ><input
                      name="connected"
                      id="home"
                      type="radio"
                      value="first"
                      onChange={() => { setcourierType(1); }}
                      checked={courierType === 1 && true}
                      className=" sec1-radio radio-btn "
                    />International</label>
                  </div>
                </div>
                <div className='col-4 inline' >
                  <label className='col-4'>Batch No</label>
                  <input className='col-6' type="text" value={batchNo} onClick={opendialagforPreviousBatch} />
                  {/* <div className='col-2'><button className='green-btn'>Lock</button> </div> */}
                </div>
                <div className='col-3 inline' >
                  <div className=''> <span className='direct'>Date&Time</span></div>
                  <div className=''> <input className='direct' type="date" name="outwardDate" max={moment().format("YYYY-MM-DD")} value={outwardDate} onChange={(e: any) => { setoutwardDate(e.target.value) }} /></div>
                  <div className=''> <input className='' type="time" name="setoutwardTime" value={outwardTime} onChange={(e: any) => { setoutwardTime(e.target.value) }} /></div>

                </div>
              </div>
              {hideshowtable && (<div className='col-12 inline'>
                <table className="table1 container">
                  <thead className="" style={{ textAlign: 'left' }}>

                    <tr style={{ textAlign: "left", border: "1px solid grey" }} >
                      <th scope="col" style={{ textAlign: 'left' }}>Sr. No.</th>
                      <th scope="col" style={{ textAlign: 'left' }}>Date</th>
                      <th scope="col" style={{ textAlign: 'left' }}>Batch No</th>
                      <th scope="col" style={{ textAlign: 'left' }}>Employee</th>
                      <th scope="col" style={{ textAlign: 'left' }}>Pcs</th>
                      <th scope="col" style={{ textAlign: 'left' }}  >Remark</th>
                    </tr>

                  </thead>


                  <tbody className="width  " style={{ border: "1px solid grey" }}>
                    {allPendigbatches.map((outward: any, index) => {
                      if (outward.pendingQuantity > 0) {
                        return <>

                          <tr key={index + 1} onClick={() => {
                            sethideshowtable(false);
                            setbatchNo(outward.batchNo);
                            setemployeeTableId(outward.employeeTableId);
                            setemployeeId(outward.employeeId);
                            setEmployeeName(outward.employeeName);
                            setcostCenter(outward.costCenter);
                            setcostCenterLabel(outward.costCenter);
                          }} >
                            <th scope="row" >{index + 1}</th>
                            <td>{outward.outwardDate}</td>
                            <td>{outward.batchNo}</td>
                            <td> {outward.employeeName}</td>
                            <td>{outward.noOfShipment}</td>
                            <td>{outward.remarks}</td>
                          </tr> </>
                      }
                    })}

                  </tbody>

                </table>
              </div>)}
              {!hideshowtable && (<div>
                <div className='col-12 inline' style={{ backgroundColor: 'grey', height: 25, color: 'white', textAlign: 'left',marginBottom : '5px' }} >
                  <div className='col-6' style={{ height: 25 }}>
                    <label className='themeColor' style={{ color: 'white', paddingLeft: '10px' }}>From Source &nbsp; </label> <label> Consignor Details    </label>
                  </div>
                  <div className='col-6' style={{ height: 25, paddingLeft: '0px' }}>
                    <label className='themeColor' style={{ color: 'white', paddingLeft: '10px' }}>To Consignee Destination &nbsp;</label> <label> <input type="radio" name="todestimationbranch" style={{ height: '12px' }} value="1" onChange={() => { onToDestinationChange(1) }} checked={outwardType === 1 && true} /> Inter Company  &nbsp;  &nbsp; </label>    <label> <input type="radio" name="todestimationbranch" style={{ height: '12px' }} value="0" onChange={() => { onToDestinationChange(0) }} checked={outwardType === 0 && true} /> Others Destination </label>
                  </div>

                </div>


                <div className='col-12 inline' style={{marginBottom: '5px'}} >

                  <div className='col-6' >
                    <div className='col-12 inline'>
                      <label className='col-4'>Consignor</label>
                      <div className='col-8' style={{paddingLeft:'0px', paddingRight :'0px'}}>
                      <Select onChange={(e: any) => { if (e !== null) { setemployeeId(e.employeeId); setEmployeeName(e.label); setemployeeTableId(e.value) } }}
                        options={allEmployee}
                        value={{ value: employeeTableId, label: employeeName }}
                        styles={customStyles} />
                    </div>
                    </div>
                    <div className='col-12 inline'>
                      <label className='col-4'>Cost Center</label>
                      <div className='col-8' style={{paddingLeft:'0px', paddingRight :'0px'}}>
                      <Select
                        name="costCenter"
                        onChange={(e: any) => { setcostCenterLabel(e.label); setcostCenter(e.value) }}
                        options={allCostCenter}
                        value={{ value: costCenter, label: costCenterLabel }}
                        styles={customStyles}
                      />
                      </div>
                    </div>

                    <div className='col-12 inline'>
                      <label className='col-4'>Employee Id :</label>
                      <label className='col-8'>  {employeeId}</label>
                    </div>
                    {/* <div className='col-12 inline'>
                    <label className='col-4'>Branch :  {branch}</label>
                  </div> */}


                    <div className='col-12 inline'>
                      <label className='col-4'>Ref No : </label>
                      <input className='col-8' type="text" value={refNo} onChange={(e: any) => { setrefNo(e.target.value); }} />
                    </div>

                    <div className='col-12 inline'>
                      <label className='col-4'>AWB No</label>
                      <input className='col-8' type="text" value={AWB} onChange={(e: any) => { setAWB(e.target.value); }} />
                    </div>

                  </div>
                  <div className='col-6' style={{ borderLeft: "1px solid #ccc" }} >
                    <div className='col-12 inline' style={{ display: detinationBranchShowhide }}>
                      <label className='col-5'>Destination Branch</label>
                      <div className='col-7' style={{paddingLeft : '0px', paddingRight : '0px'}}>
                      <Select
                        name="consigneeBranchId"
                        onChange={handleBranchChange}
                        options={allBranch}
                        value={{ value: consigneeBranchId, label: consigneebranchLabel }}
                        styles={customStyles}
                      />
                      </div>
                    </div>
                    <div className='col-12 inline'>
                      <label className='col-4'>Consignee</label>
                      <div className='col-8' style={{paddingLeft:'0px', paddingRight :'0px'}}>
                      <CreatableSelect isClearable options={allSelections}
                      defaultValue ={consigneeId}
                        onChange={(e: any) => { if (e !== null) { setconsigneeId(e.value); setconsigneeName(e.label); } }}
                          />
</div>
                    </div>


                    <div className='col-12 inline'>
                      <label className='col-4'>Pincode </label>
                      <div className='col-8' style={{paddingLeft:'0px', paddingRight :'0px'}}>
                      <AsyncSelect
                        name="pincode"
                        // onInputChange={(input) => setInputValue(input)}
                        onChange={(e: any) => { setPincodeId(e.value); setconsigneeZipCode(e.label); }}
                        loadOptions={handleInputChange}
                        value={{ value: pincodeId, label: consigneeZipCode }}
                        styles={customStyles}
                      />
                      </div>
                    </div>
                    <div className='col-12 inline'>
                      <label className='col-4'>Area Details</label>
                      <input className='col-8' type="text" value={consigneeAreaName} onChange={(e: any) => { setconsigneeAreaName(e.target.value); }} />
                    </div>
                    <div className='col-12 inline'>
                      <label className='col-4'>City</label>
                      <input className='col-8' type="text" value={consigneeCityName} onChange={(e: any) => { setconsigneeCityName(e.target.value); }} readOnly />
                    </div>
                    <div className='col-12 inline'>
                      <label className='col-4'>State</label>
                      <input className='col-8' type="text" value={consigneeStateName} onChange={(e: any) => { setconsigneeStateName(e.target.value); }} readOnly />
                    </div>
                    <div className='col-12 inline'>
                      <label className='col-4'>Country </label>
                      <input className='col-8' type="text" value={consigneeCountryCode} onChange={(e: any) => { setconsigneeCountryCode(e.target.value); }} readOnly />
                    </div>
                  </div>
                </div>
                <div className='col-12 inline' style={{ borderTop: "1px solid #ccc", paddingTop: '5px' }}   >
                  <div className='col-6'>
                    <div className='col-12 inline'>
                      <label className='col-4'>Service Provider</label>
                      <div className='col-8' style={{paddingLeft:'0px', paddingRight :'0px'}}>
                      <Select
                        name="serviceProviderId"
                        onChange={(e: any) => {
                          setserviceProviderId(e.value);
                          setserviceProvider(e.label)
                        }}
                        options={serviceProviderList}
                        value={{ value: serviceProviderId, label: serviceProvider }}
                      />
                      </div>
                    </div>
                    <div className='col-12 inline'>
                      <label className='col-4'>Product</label>
                      <div className='col-8' style={{paddingLeft:'0px', paddingRight :'0px'}}>
                      <Select
                        name="product"
                        onChange={(e: any) => {
                          setproduct(e.value);
                          setproductName(e.label)
                        }}
                        options={allProduct}
                        value={{ value: product, label: productName }}
                      />
                      </div>
                    </div>
                    <div className='col-12 inline'>
                      <label className='col-4'>Zone</label>
                      <input type="text" value={zoneName} className='col-8' readOnly />
                    </div>
                    <div className='col-12 inline'>
                      <label className='col-6'>Delivery TAT : <span style={{ color: "red", fontWeight: 'bold' }}>  {deliveryTat}  </span> </label>
                      <label className='col-6'>Servicable  : <span style={{ color: "green", fontWeight: 'bold' }}> {serviceStatus}</span> </label>
                    </div>
                    <div className='col-12 inline'>
                      <label className='col-4'>Mail Content </label>
                      <input className='col-8' type="text" value={mailContent} onChange={(e: any) => { setmailContent(e.target.value); }} />
                    </div>
                    <div className='col-12 inline'>
                      <label className='col-4'>Shipment Type </label>
                      <label className='col-4'><input type="radio" name="shipmentType" value="0" checked={shipmentType === 0 && true} onChange={() => { setshipmentType(0) }}  /> Official </label>
                      <label className='col-4'> <input type="radio" name="shipmentType" value="1" checked={shipmentType === 1 && true} onChange={() => { setshipmentType(1) }} /> Personal </label>
                    </div>

                  </div>
                  <div className='col-6'>
                    <div className='col-12 inline'>

                      <label className='col-3'>No Of Pcs. </label>
                      <input className='col-3 text-right' type="text" value={numberOfPieces} onChange={(e: any) => { if (/^\d*\.?\d{0,2}$/.test(e.target.value)) { setnumberOfPieces(e.target.value); } }} />
                      <label className='col-3'>Act. Wt. </label>
                      <input className='col-3 text-right' type="text" value={weight} onChange={(e: any) => { if (/^\d*\.?\d{0,3}$/.test(e.target.value)) { setweight(e.target.value); } }} />

                    </div>

                    <div className='col-12 inline'>
                      <div className='col-6' style={{ paddingRight: '0px' }}>
                        <label className='col-3' style={{ fontSize: '11px', padding: "0px", fontWeight: 600 }}> Vol. Wt. </label>
                        <input className='col-3' style={{ padding: "0px", textAlign: 'right' }} type="text" placeholder='Length' value={boxlength} onChange={(e: any) => { if (/^\d*\.?\d{0,3}$/.test(e.target.value)) { setboxLength(e.target.value) } }} />
                        <input className='col-3' style={{ padding: "0px", textAlign: 'right' }} type="text" placeholder='Width' value={boxwidth} onChange={(e: any) => { if (/^\d*\.?\d{0,3}$/.test(e.target.value)) { setBoxWidth(e.target.value); } }} />
                        <input className='col-3' style={{ padding: "0px", textAlign: 'right' }} type="text" placeholder='Height' value={boxheight} onChange={(e: any) => { if (/^\d*\.?\d{0,3}$/.test(e.target.value)) { setBoxHeight(e.target.value); } }} />
                      </div>

                      <label className='col-3'>Vol. Wt. </label>
                      <input className='col-3 text-right' type="text" value={volumetricWeight} onChange={(e: any) => { setvolumetricWeight(e.target.value); }} readOnly />

                    </div>
                    <div className='col-12 inline'>
                      <label className='col-3'>Net Amt. </label>
                      <input className='col-3 text-right' type="text" value={netAmount} onChange={(e: any) => { setnetAmount(e.target.value); }} readOnly />

                      <label className='col-3'> Fuel SurC.</label>
                      <input className='col-3 text-right' type="text" value={fuelCharges} onChange={(e: any) => { setfuelCharges(e.target.value); }} readOnly />
                    </div>
                    <div className='col-12 inline'>
                      <label className='col-3'> GST (18%)</label>
                      <input className='col-3 text-right' type="text" value={GST} onChange={(e: any) => { setGST(e.target.value); }} readOnly />
                      <label className='col-3'>Other C. </label>
                      <input className='col-3 text-right' type="text" value={otherCharges} onChange={(e: any) => { if (/^\d*\.?\d{0,2}$/.test(e.target.value)) { setotherCharges(e.target.value); } }} />

                    </div>
                    <div className='col-12 inline'>
                      <div className='col-6'></div>
                      <label className='col-3'>Gross Total </label>
                      <input className='col-3 text-right' type="text" value={grossAmount} onChange={(e: any) => { setgrossAmount(e.target.value); }} readOnly />
                    </div>

                  </div>
                </div>
              </div>
              )}
            </div>

            <div>
              <div className='btn d-flex justify-content-center'>
                {(state === null) ? <button className="btn2 col-2 col-sm-1" type="button" onClick={handleSubmit}><i className="fa fa-save"></i> Save</button> : <>
                  <Link className="btn2 col-2 col-sm-1" onClick={handleEdit} to="/branchlist"><i className="fa fa-edit"></i> Update </Link>
                  <button className="btn2 col-2 col-sm-1" onClick={handleDelete}> <i className="fa fa-trash"></i> Delete</button></>}
                <button className="btn2 col-2 col-sm-1" onClick={clearForm} > <i className="fa fa-close" ></i> Clear</button>
                <Link className="btn2 col-2 col-sm-1" to="/inwardloglist" type='button'>  <i className="fa fa-sign-out"></i> Close </Link>

              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}

    </>

  )
}
export default Outwarddetailentry